// @ts-expect-error - TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'HeadType'. Did you mean to use 'import HeadType from "@atlaskit/dynamic-table"' instead?
import type { HeadType } from '@atlaskit/dynamic-table';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import {
	ARCHIVE_STATUS,
	DELETE_STATUS,
	NAME,
	KEY,
	LEAD,
	DELETED_DATE,
	ARCHIVED_DATE,
	DELETING_IN,
} from '../../../common/constants.tsx';
import type { Status } from '../../../common/types.tsx';
import messages from './messages.tsx';

export default function getTableHeader({ formatMessage }: IntlShape, status: Status): HeadType {
	const archiveHeaders = [
		{
			key: ARCHIVED_DATE,
			content: formatMessage(messages.archivedOn),
			isSortable: true,
			testId: 'jira-inactive-projects-directory-base.projects-table.header.archived-date',
		},
	];
	const deleteHeaders = [
		{
			key: DELETED_DATE,
			content: formatMessage(messages.deletedOn),
			isSortable: true,
			testId: 'jira-inactive-projects-directory-base.projects-table.header.deleted-date',
		},
		{
			key: DELETING_IN,
			content: formatMessage(messages.deletingIn),
			isSortable: false,
			testId: 'jira-inactive-projects-directory-base.projects-table.header.deleting-in',
		},
	];
	return {
		cells: [
			{
				key: NAME,
				content: formatMessage(messages.name),
				isSortable: true,
				testId: 'jira-inactive-projects-directory-base.projects-table.header.name',
			},
			{
				key: KEY,
				content: formatMessage(messages.key),
				isSortable: true,
				width: gridSize,
				testId: 'jira-inactive-projects-directory-base.projects-table.header.key',
			},
			{
				key: 'type',
				content: formatMessage(messages.type),
				testId: 'jira-inactive-projects-directory-base.projects-table.header.type',
			},
			{
				key: LEAD,
				content: formatMessage(messages.lead),
				isSortable: true,
				testId: 'jira-inactive-projects-directory-base.projects-table.header.lead',
			},
			...(status === ARCHIVE_STATUS ? archiveHeaders : []),
			...(status === DELETE_STATUS ? deleteHeaders : []),
			{
				content: '',
				width: gridSize,
				testId: 'jira-inactive-projects-directory-base.projects-table.header.actions',
			},
		],
	};
}
